module.exports = __webpack_public_path__ + "static/media/17.595b87c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/17.jpg
// module id = 578
// module chunks = 0